export default __webpack_public_path__ + "static/media/Medium's Boots of the Kingmaker.862dfcb3.jpg";